module.exports = __webpack_public_path__ + "static/media/BeJammin.c232815f.mp3";